module.exports = __webpack_public_path__ + "img/business8.da0a0f20.png";